var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"playRegionDomRef",staticClass:"stream-play-container",attrs:{"id":_setup.playRegionDomId}})
}
var staticRenderFns = []

export { render, staticRenderFns }